import React, { useState, useEffect } from "react";
import logo from "../../resource/7.png";
import Swal from "sweetalert2";
import axios from "axios";
import apiClient from "@/api/client";

const SoloRetreatRequestForm = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    last_name: "",
    date_of_birth: "",
    age: 0,
    gender: "",
    address: "",
    city: "",
    postal_code: "",
    mobile_number: "",
    whatsapp_number: "",
    email_address: "",
    is_beginner: false,
    is_experienced: false,
    number_of_days: 0,
    solo_retreatant_clarification: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setFormData((prevFormData) => ({
          ...prevFormData,
          ip_address: response.data.ip, // Set the IP address
        }));
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIP();
  }, []);

  const validateForm = () => {
    const newErrors = {};

    // Validate Full Name
    if (!formData.full_name) newErrors.full_name = "First Name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.full_name))
      newErrors.full_name =
        "First Name should contain only letters, spaces, or hyphens";

    // Validate Last Name
    if (!formData.last_name) newErrors.last_name = "Last Name is required";
    else if (!/^[A-Za-z\s\-]+$/.test(formData.last_name))
      newErrors.last_name =
        "Last Name should contain only letters, spaces, or hyphens";

    // Validate Mobile Number
    if (!formData.mobile_number)
      newErrors.mobile_number = "Mobile Number is required";
    else if (!/^\d{10}$/.test(formData.mobile_number))
      newErrors.mobile_number = "Mobile Number should be 10 digits";

    // Validate Date of Birth
    if (!formData.date_of_birth)
      newErrors.date_of_birth = "Date of Birth is required";

    // Validate Age
    if (!formData.age) newErrors.age = "Age is required";
    else if (isNaN(formData.age) || formData.age <= 0)
      newErrors.age = "Age must be a valid number";

    // Validate Email
    if (!formData.email_address)
      newErrors.email_address = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email_address))
      newErrors.email_address = "Invalid email format";

    // Validate WhatsApp
    if (!formData.whatsapp_number)
      newErrors.whatsapp_number = "WhatsApp Number is required";
    else if (!/^\d{10}$/.test(formData.whatsapp_number))
      newErrors.whatsapp_number = "WhatsApp Number should be 10 digits";

    // Validate Number of Days
    if (!formData.number_of_days)
      newErrors.number_of_days = "Number of Days is required";
    else if (isNaN(formData.number_of_days) || formData.number_of_days <= 0)
      newErrors.number_of_days = "Enter a valid number of days";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateSelectionForm = () => {
    const { is_beginner, is_experienced } = formData;

    const isValid = is_beginner || is_experienced;
    return isValid;

  }

  const validateAll = () => {
    const isFormValid = validateForm();
    const isSelectionValid = validateSelectionForm();

    if (!isFormValid) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check the highlighted fields and try again.",
      });
      return false;
    }

    if (!isSelectionValid) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please select at least one item under the Punyannumodana for the deceased.",
      });
      return false;
    }

    return true; // All validations passed
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Force number fields to store actual numbers
  const numericFields = ["age", "number_of_days"];
  const newValue =
    type === "checkbox"
      ? checked
      : numericFields.includes(name)
      ? parseInt(value, 10)
      : value;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: newValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateAll()) {
      return; // Stop execution if validation fails
    }

    setLoading(true);

    try {
      const response = await apiClient.post('/solo-retreats',
        formData
      );

      console.log("Form submitted successfully:", response.data);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Form submitted successfully!",
      });

      // Reset the form
      setFormData({
        full_name: "",
        last_name: "",
        date_of_birth: "",
        age: 0,
        gender: "",
        address: "",
        city: "",
        postal_code: "",
        mobile_number: "",
        whatsapp_number: "",
        email_address: "",
        is_beginner: false,
        is_experienced: false,
        number_of_days: 0,
        solo_retreatant_clarification: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      let errorMessage = "Something went wrong!";
      if (error.response) {
        errorMessage = error.response.data.message || "An error occurred while submitting the form.";
      } else if (error.request) {
        errorMessage = "No response from the server. Please try again later.";
      }
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="form-page dark-gold">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Solo Retreat Registration Form </h2>
          </div>
        </div>

        <p className="font-p mt-6">
          Welcome to Bhaddheka Vihari Monastery Solo Retreats.
        </p>
        <p className="font-p mt-4">
          Use the following form to fill in the Solo retreatant’s details
        </p>

        {/* Full Name */}
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleInputChange}
            />
            <label>First Name</label>
            {errors.full_name && <span className="error">{errors.full_name}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
            />
            <label>Last Name</label>
             {errors.last_name && <span className="error">{errors.last_name}</span>}
          </div>
        </div>

        {/* DOB & Age */}
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="date"
              name="date_of_birth"
              value={formData.date_of_birth}
              onChange={handleInputChange}
            />
            <label>Date of Birth*</label>
             {errors.date_of_birth && <span className="error">{errors.date_of_birth}</span>}
          </div>
          <div className="form-item">
            <input
              type="number"
              name="age"
              value={formData.age}
              onChange={handleInputChange}
            />
            <label>Age*</label>
             {errors.age && <span className="error">{errors.age}</span>}
          </div>
        </div>

        {/* Gender */}
        <p className="font-p mt-5">Gender*</p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              name="gender"
              value="Male"
              checked={formData.gender === "Male"}
              onChange={handleInputChange}
            />
            <label>Male</label>
          </div>
          <div>
            <input
              type="radio"
              name="gender"
              value="Female"
              checked={formData.gender === "Female"}
              onChange={handleInputChange}
            />
            <label>Female</label>
          </div>
          {errors.gender && <span className="error">{errors.gender}</span>}
        </div>

        {/* Address */}
        <p className="font-p mt-5">Address*</p>
        <div className="form-box1">
          <div className="form-item">
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
            <label>Address</label>
             {errors.address && <span className="error">{errors.address}</span>}
          </div>
        </div>

        {/* City */}
        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
            />
            <label>City</label>
             {errors.city && <span className="error">{errors.city}</span>}
          </div>
        </div>

        {/* Postal Code */}
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              name="postal_code"
              value={formData.postal_code}
              onChange={handleInputChange}
            />
            <label>Postal/Zip Code*</label>
             {errors.postal_code && <span className="error">{errors.postal_code}</span>}
          </div>
        </div>

        {/* Mobile & WhatsApp */}
        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleInputChange}
            />
            <label>Mobile Number</label>
             {errors.mobile_number && <span className="error">{errors.mobile_number}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              name="whatsapp_number"
              value={formData.whatsapp_number}
              onChange={handleInputChange}
            />
            <label>WhatsApp Number</label>
             {errors.whatsapp_number && <span className="error">{errors.whatsapp_number}</span>}
          </div>
        </div>

        {/* Email */}
        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="email"
              name="email_address"
              value={formData.email_address}
              onChange={handleInputChange}
            />
            <label>Email Address</label>
             {errors.email_address && <span className="error">{errors.email_address}</span>}
          </div>
        </div>

        {/* Beginner / Experienced */}
        <p className="font-p mt-5">
          Please indicate if the Solo retreatant is a beginner or an experienced meditator
        </p>
        <div className="selection mt-4">
          <div className="checkbox-box">
            <label>Beginner</label>
            <input
              type="checkbox"
              name="is_beginner"
              checked={formData.is_beginner}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label>Experienced</label>
            <input
              type="checkbox"
              name="is_experienced"
              checked={formData.is_experienced}
              onChange={handleInputChange}
            />
          </div>
             
        </div>

        {/* Duration */}
        <p className="font-p mt-5">
          Please indicate the duration you intend to reside at the Monastery
        </p>
        <div className="form-item mt-5">
          <label>No of Days</label>
          <input
            type="number"
            name="number_of_days"
            value={formData.number_of_days}
            onChange={handleInputChange}
          />
           {errors.number_of_days && <span className="error">{errors.number_of_days}</span>}
        </div>

        {/* Clarifications */}
        <p className="font-p mt-5">
          Please write any specific questions or queries you would like to clarify
        </p>
        <div className="mt-5">
          <div className="form-item">
            <textarea
              name="solo_retreatant_clarification"
              value={formData.solo_retreatant_clarification}
              onChange={handleInputChange}
              rows="6"
            />
          </div>
           
        </div>

        <button type="submit" id="submitbtn" className="mt-5">
          {loading ? "Submitting..." : "Submit"}
        </button>

        <p className="font-p mt-5 pb-4">
          We look forward to facilitating your request and are grateful for
          choosing Bhaddheka Vihari Monastery as an enriching space for practising
          mindfulness meditation
        </p>
      </form>
    </div>
  );
};

export default SoloRetreatRequestForm;
